import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fixedDigit' })
export class FixedDigitPipe implements PipeTransform {
  transform(value: number, digits: number = 2): string {
    return value.toString().padStart(digits, '0');
  }
}
